var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApprovals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5816 8.13419C22.1396 8.69226 22.1396 9.5941 21.5816 10.1522L10.1523 21.5814C9.59422 22.1395 8.69238 22.1395 8.13431 21.5814L2.41842 15.8668C1.86053 15.3087 1.86053 14.4069 2.41842 13.8488C2.9764 13.2908 3.88092 13.2908 4.43899 13.8488L9.10312 18.55L19.5636 8.13419C20.1216 7.57612 21.0235 7.57612 21.5816 8.13419Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.2955 2.41822C17.8536 2.97629 17.8536 3.88081 17.2955 4.43888L10.1523 11.5808C9.59418 12.1389 8.69234 12.1389 8.13427 11.5808L4.56128 8.00919C4.00366 7.45112 4.00366 6.54927 4.56128 5.9912C5.11935 5.43313 6.02387 5.43313 6.5806 5.9912L9.10308 8.5494L15.2776 2.41822C15.8356 1.86059 16.7375 1.86059 17.2955 2.41822Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApprovals);
export default __webpack_public_path__ + "static/media/icon-approvals.1a68851fc36099b60e661cc099f55fec.svg";
export { ForwardRef as ReactComponent };